import { cronosProviderConfiguration } from 'src/features/on-chain/calculation-manager/providers/dexes/cronos/default-constants';

export const CRO_SWAP_CONTRACT_ADDRESS = '0x6c3A0E2E78848274B7E3346b8Ef8a4cBB2fEE2a9';

export const CRO_SWAP_PROVIDER_CONFIGURATION = cronosProviderConfiguration;
